export default __webpack_public_path__ + "static/Screen Shot 2022-05-31 at 15.08.48-94ec638ac03290d17b365a111de31c08.png";